export class IPix {
  type: string; // random, person, phone and email
  key: string;
  document: string;
  name: string;
  city: string;
}
